module.exports = __webpack_public_path__ + "img/performance.e1a52e3e.svg";